module.exports = {
  "notification": {
    notificationManager: "通知管理"
  },
};



// WEBPACK FOOTER //
// ./src/i18n/notification/en.js